import React, { FC } from "react";
import { Button, CircularProgress } from "@mui/material";
import Box from "../Box";
import TimeSlotCalendarDateSwitcher from "../../TimeSlot/TimeSlotCalendarDateSwitcher";

type Props = {
  weekStart: Date;
  weekEnd: Date;
  onPrevClick: () => void;
  onNextClick: () => void;
  isEditMode: boolean;
  canEdit: boolean;
  isTablePending: boolean;
  isSaving: boolean;
  onEditClick: () => void;
  onCancelEdit: () => void;
  onSave: () => void;
};

const AvailabilityToolbar: FC<Props> = ({
  weekStart,
  weekEnd,
  onPrevClick,
  onNextClick,
  isEditMode,
  canEdit,
  isTablePending,
  isSaving,
  onEditClick,
  onCancelEdit,
  onSave,
}) => (
  <Box pb={3} display="flex" alignItems="center" justifyContent="space-between">
    <TimeSlotCalendarDateSwitcher
      start={weekStart}
      end={weekEnd}
      view="week"
      onPrevClick={onPrevClick}
      onNextClick={onNextClick}
    />
    <Box display="flex" alignItems="center" gap={2}>
      {isEditMode ? (
        <>
          <Button variant="outlined" onClick={onCancelEdit} disabled={isSaving}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onSave}
            disabled={isSaving}
            startIcon={isSaving ? <CircularProgress size={16} /> : null}
          >
            Save
          </Button>
        </>
      ) : (
        canEdit && (
          <Button
            variant="contained"
            onClick={onEditClick}
            disabled={isTablePending}
          >
            Edit
          </Button>
        )
      )}
    </Box>
  </Box>
);

export default AvailabilityToolbar;
